import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";

/**
 * At least one of the organization's Vibe usage types sits in the warning band —
 * above 80% of its soft cap and not yet over it.
 *
 * One row per organization, with every type in the band on rawPayload. The
 * sweep reports it on every tick it holds and resolves it by set difference on
 * every tick it does not, so the row is open exactly while the organization is
 * in the band. Crossing the cap moves it out of the band and into
 * `VIBE_COST_SAFETY_SOFT_LIMIT_CROSSED`; the period rollover empties it.
 *
 * Not paged, for the reason its sibling is not: a forecast of a soft limit is a
 * spend signal the customer's admins are already emailed about, once per period.
 */
export const VIBE_COST_SAFETY_SOFT_LIMIT_APPROACHING = {
  category: ISSUE_CATEGORY.BILLING,
  message:
    "This organization's Vibe consumption is above 80% of a soft cap for the billing period and has not crossed it yet. rawPayload lists each usage type in that band with its sum, its cap and the period. The organization's admins are emailed once per period per type. Cleared automatically once no type is in the band.",
  severity: "low",
  remedy:
    "Nothing is broken; this is a forecast. If the usage is expected, raise the cap before it crosses; otherwise nothing needs doing — crossing only warns, it never suspends."
} as const satisfies IssueDefinition;
